import { WhitelabelConfig } from 'hooks'
import React, { useEffect, useState } from 'react'

const totalEls = 32
const volumePoints = [...new Array(totalEls).keys()]

export const VolumeMeter = ({ deviceId }) => {
    const [average, setAverage] = useState(0)

    useEffect(() => {
        let cleanupFunction = false
        navigator.mediaDevices.getUserMedia({ audio: { deviceId }, video: false }).then((stream) => {
            try {
                const audioContext = new AudioContext()
                const analyser = audioContext.createAnalyser()
                const microphone = audioContext.createMediaStreamSource(stream)
                const javascriptNode = audioContext.createScriptProcessor(4096, 1, 1)
                const bufferLength = analyser.frequencyBinCount

                analyser.smoothingTimeConstant = 0.3
                analyser.fftSize = 1024

                microphone.connect(analyser)
                analyser.connect(javascriptNode)
                javascriptNode.connect(audioContext.destination)
                javascriptNode.onaudioprocess = () => {
                    const array = new Uint8Array(bufferLength)
                    analyser.getByteFrequencyData(array)
                    let values = 0
                    for (let i = 0; i < bufferLength; i++) {
                        values += array[i]
                    }
                    !cleanupFunction && setAverage(Math.round(((values / bufferLength) * 100) / totalEls))
                }
            } catch (e) {
                console.warn(e)
            }
        })
        return () => (cleanupFunction = true)
    }, [deviceId])

    return (
        <div className="sound-and-devices__volume-meter d-flex justify-content-between">
            {volumePoints.map((point) => {
                let opacity = 1

                if (point > average - 3 && point <= average) {
                    opacity = 0.4
                } else if (point > average - 5 && point <= average - 3) {
                    opacity = 0.6
                } else if (point > average - 8 && point <= average - 5) {
                    opacity = 0.8
                } else if (point > average) {
                    opacity = 0.08
                }

                const pointColorHsl = WhitelabelConfig.colors['volume-meter-point-hsl']
                const initialBgColor = `hsl(${pointColorHsl}, ${opacity})`

                return (
                    <span
                        key={point}
                        className="sound-and-devices__volume-meter__point"
                        style={{ backgroundColor: initialBgColor }}
                    />
                )
            })}
        </div>
    )
}
